export default {
    ja: {
        contents: {
            heading: 'CONTENTS',
            readMore: '続きを読む',
            close: '閉じる',
            external: '公式サイト',
            items: [

                {
                    id: 'con-01',
                    subtitle: '奇岩遊仙境',
                    title: 'プロジェクションマッピング『石のきせき』',
                    description: '「小松の石文化」を象徴する奇岩遊仙境に、石の力と自然智を映し出すプロジェクションマッピング。\n' +
                        '地元の子どもたちが文化の繁栄を願って描いた石切りの妖精も登場。\n' +
                        '石が紡いできた時間の流れと、自然の力強さをお届けします。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-02',
                    subtitle: '山門',
                    title: 'ライトアップ',
                    description: '左右の扉に阿吽の仁王像が彫られた山門がライトアップされ、皆さまをお迎え。\n' +
                        '心清らかな気持ちにして、自然智を感じるNAKED夜さんぽの始まり。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-03',
                    subtitle: '金堂華王殿',
                    title: 'ライトアップ',
                    description: 'ライトアップされた金堂華王殿は、鮮やかな朱色が印象的な鎌倉時代の様式で再現した現代の名建築。建物内には、高さ7.8mの巨大な十一面千手観世音菩薩が鎮座。厳かな雰囲気をまとった観音様に祈りを捧げ、慈悲のささやきに耳を澄ます。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-04',
                    subtitle: '参道',
                    title: 'ライトアップ『秘道』『石幻道』',
                    description: '水路と行燈の淡い光に照らされた苔むす参道を、静かな音楽が包み込みます。\n' +
                        'ミストスモークが漂い、石に宿る力を感じさせるような、秘境へと続く神秘的な道が現れます。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-05',
                    subtitle: '鎮守堂',
                    title: 'ライトアップ',
                    description: '秀麗な白山の神様であられる白山妙理大権現をお祀りしている「鎮守堂」。ライトアップによってやわらかな光に包まれます。\n' +
                        '静謐な空間に浮かび上がるその姿は、祈りと守護の象徴。\n' +
                        '歴史を刻む堂宇に光が宿り、訪れる人々をやさしく見守ります。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },

                {
                    id: 'con-06',
                    subtitle: '三重塔',
                    title: 'ライトアップ',
                    description: '国の重要文化財であり、三層すべてに扇垂木を用いた精緻な構造を誇る三重塔をライトアップ。\n' +
                        '建造物の華麗さと荘厳さが光に浮かび上がり、訪れる人々に歴史と美の奥深さを伝えます。',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-07',
                    subtitle: '',
                    title: 'NAKED花みくじ®︎',
                    description: 'お花をモチーフとした、NAKEDの大人気おみくじ。みくじ結びで花を咲かせるアートに参加するも、持ち帰ってお土産にするもOK。\n' +
                        '※お支払いは現金・PayPay・クレジットカードが使用できます。\n'+
                        '販売価格：500円（税込）',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-08',
                    subtitle: '',
                    title: 'NAKEDディスタンス提灯®︎',
                    description: 'NAKEDが開発したアートな提灯。提灯を片手に巡れば、地面に映し出される様々な光りが会場を鮮やかに彩り、自分自身も光のアートの一部になることができます。提灯の光の色のバリエーションは、九谷焼の彩法の「五彩」紺青・赤・紫・緑・黄をイメージしています。そして今年は自分だけのオリジナルカラーで楽しむことができるできるワークショップも開催！',
                    note: '※数量限定',
                    price: 'レンタル価格：500円(税込)',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-09',
                    subtitle: '普門閣・宝物館',
                    title: '写真展「漆原康夫写真展　ひこばえ　孫生え　蘖」',
                    description: '能登、輪島を中心に撮り溜めていた、祭りや婚礼、生業、景色といった、人々の暮らしが生き生きとうつされた写真の数々を展示、映写機で投写',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },

                {
                    id: 'con-10',
                    subtitle: '',
                    title: 'コラボ御朱印',
                    description: '『NAKED夜さんぽ™ 石川・那谷寺 』では期間中、テーマである石の力をイメージしたコラボ御朱印を販売します。',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
            ],
        },
    },
    en: {
        contents: {
            heading: 'CONTENTS',
            readMore: 'Show more',
            close: 'Close',
            external: '公式サイト',
            items: [

                {
                    id: 'con-01',
                    subtitle: 'Kigan Yusenkyou',
                    title: 'Projection Mapping “Ishi no Kiseki”',
                    description: 'At Kigan Yusenkyō, the symbolic landscape of Komatsu’s stone culture, projection mapping reveals the power of stone and the wisdom of nature.\n' +
                        'Stone fairies, drawn by local children with wishes for cultural prosperity, also make an appearance.\n' +
                        'This piece conveys the flow of time shaped by stone and the strength of nature.',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-02',
                    subtitle: 'Sanmon Gate',
                    title: 'Illumination',
                    description: 'The illuminated Sanmon, with statues of the Nio guardians carved into the doors on both sides, welcomes you. This marks the beginning of NAKED\'s Night Walk, inviting you to clear your mind and bask in the wisdom of nature.',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-03',
                    subtitle: 'KondouKeouden',
                    title: 'Illumination',
                    description: 'The illuminated KondouKeouden, a modern architectural masterpiece, is recreated in the vibrant red style of the Kamakura period. Inside the hall, a magnificent 7.8-meter-tall statue of the Eleven-Faced Thousand-Armed Kannon stands. Offer your prayers to this solemn figure and listen for its whispers of compassion.',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-04',
                    subtitle: 'Sandou Pathway',
                    title: 'illumination “Hido” "Ishigendo”',
                    description: 'Soft lights from the water channels and lanterns illuminate the moss-covered path, while gentle music fills the air. ',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-05',
                    subtitle: 'Chinju-dō',
                    title: 'illumination',
                    description: 'Chinju-dō, dedicated to Hakusan Myōri Daigongen, the guardian deity of the majestic Mt. Hakusan, is gently bathed in soft light.\n' +
                        'Its illuminated presence in the tranquil space becomes a symbol of prayer and protection.\n' +
                        'As light graces this historic hall, it offers visitors a serene sense of being quietly watched over.',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },

                {
                    id: 'con-06',
                    subtitle: 'Three-Story Pagoda',
                    title: 'Illumination',
                    description: 'The Three-Story Pagoda, a nationally designated Important Cultural Property celebrated for its intricate structure with fan rafters on all three levels, is dramatically illuminated.\n' +
                        'Its architectural elegance and grandeur emerge in the light, offering visitors a profound encounter with history and beauty.',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-07',
                    subtitle: '',
                    title: 'NAKED Hanamikuji®︎',
                    description: 'NAKED\'s popular "omikuji" paper fortunes come in the form of colorful flowers. These flowers can be contributed to a local installation to create a larger floral artwork, or be taken home as a souvenir. \n' +
                        '\n' +
                        '*500 yen per flower fortune (tax included).\n' +
                        '*We accept cash, PayPay, and credit card payments.',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-08',
                    subtitle: '',
                    title: 'NAKED Distance Lantern®',
                    description: 'Artistic lanterns designed by NAKED. As you walk through the venue with a lantern in hand, various patterns of light projected on the ground will illuminate the space, making you a part of the light art itself. The color variations of the lanterns are inspired by the "Gosai" (five colors) technique of Kutani ware: navy blue, red, purple, green, and yellow.\n' +
                        '\n' +
                        'And this year, we’re also hosting a special workshop where you can create your own original lantern color!',
                    note: '*Rental price: 500JPY (tax included)\n' +
                        '*Please note that availability is limited, and there may be a wait.\n' +
                        '*In addition to cash, contactless payments via credit or debit cards and select payment services are available. Please check on-site for details.',
                    price: 'Rental price: 500JPY (tax included)',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
                {
                    id: 'con-09',
                    subtitle: 'Fumonkaku (House of Sutras), Houmotsukan',
                    title: 'Yasuo Urushibara Photo Exhibition\n' +
                        '“Hikoba-e: Sprouts of Life”',
                    description: 'This exhibition presents a vivid collection of photographs by Yasuo Urushibara, capturing the essence of everyday life—festivals, weddings, traditional livelihoods, and landscapes—mainly in the Noto and Wajima regions. The works will be displayed and projected using a film projector.',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },

                {
                    id: 'con-10',
                    subtitle: '',
                    title: 'Collaborative Goshuin',
                    description: 'During “NAKED Yoru-Sanpo™ at Natadera in Ishikawa,” a special collaborative Goshuin (temple stamp) inspired by the event’s central theme—the spiritual power of stones—will be available for purchase.',
                    note: '',
                    price: '',
                    copyright: '',
                    showTitle: true,
                    showSubtitle: true,
                    link: '',
                    visible: true,
                },
            ],
        },
    },

}



// idごとに対応する画像パスを定義
const imagePathsMapping = {
    'con-01': 'Images/contents/con-01_r.webp',
    'con-02': 'Images/contents/con-02_r.webp',
    'con-03': 'Images/contents/con-03_r.webp',
    'con-04': 'Images/contents/con-04_r.webp',
    'con-05': 'Images/contents/con-05_r.webp',
    'con-06': 'Images/contents/con-06_r.webp',
    'con-07': 'Images/contents/con-07.webp',
    'con-08': 'Images/contents/con-08.webp',
    'con-09': 'Images/contents/con-09.webp',
    'con-10': 'Images/contents/con-10.webp',
};

// セットベースの順序制御システム
const setOrder = {
    'set-1': {
        order: 1,
        largeIndices: [0, 7, 10], // 0, 7, 10番目のカードがlarge
        cards: [
            { id: 'con-01' },
            { id: 'con-02' },
            { id: 'con-03' },
            { id: 'con-04' },
            { id: 'con-05' },
            { id: 'con-06' },
            { id: 'con-07' },
            { id: 'con-08' },
            { id: 'con-09' },
            { id: 'con-10' },
        ]
    }
};

export { imagePathsMapping, setOrder };